import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { ThumbsUp, ThumbsDown } from "lucide-react";

interface MobileApprovalButtonsProps {
  onApproveClick: () => void;
  onDeclineClick: () => void;
}

const MobileApprovalButtons: React.FC<MobileApprovalButtonsProps> = ({
  onApproveClick,
  onDeclineClick,
}) => {
  const { t } = useTranslation(['documents']);

  return (
    <div
      className="flex justify-center gap-4 mt-6 md:hidden"
      data-pol-id="0mcwa2"
      data-pol-file-name="mobile-approval-buttons"
      data-pol-file-type="component"
    >
      <Button
        size="icon"
        className="h-14 w-14 rounded-full bg-green-500 hover:bg-green-600 shadow-lg"
        onClick={onApproveClick}
        data-pol-id="j8ejxg"
        data-pol-file-name="mobile-approval-buttons"
        data-pol-file-type="component"
      >
        <ThumbsUp
          className="h-6 w-6"
          data-pol-id="3p6tek"
          data-pol-file-name="mobile-approval-buttons"
          data-pol-file-type="component"
        />
        <span
          className="sr-only"
          data-pol-id="dq13j0"
          data-pol-file-name="mobile-approval-buttons"
          data-pol-file-type="component"
        >
          {t('documents:viewer_approve_document_sr')}
        </span>
      </Button>

      <Button
        size="icon"
        variant="outline"
        className="h-14 w-14 rounded-full border-red-500 text-red-500 hover:bg-red-100 hover:text-red-600 shadow-lg"
        onClick={onDeclineClick}
        data-pol-id="t5l6yd"
        data-pol-file-name="mobile-approval-buttons"
        data-pol-file-type="component"
      >
        <ThumbsDown
          className="h-6 w-6"
          data-pol-id="j50bz3"
          data-pol-file-name="mobile-approval-buttons"
          data-pol-file-type="component"
        />
        <span
          className="sr-only"
          data-pol-id="jpmunh"
          data-pol-file-name="mobile-approval-buttons"
          data-pol-file-type="component"
        >
          {t('documents:viewer_decline_document_sr')}
        </span>
      </Button>
    </div>
  );
};

export default MobileApprovalButtons;
